import { string, number } from '@thd-nucleus/data-sources';

export const activatePerksModel = {
  id: string(),
  rewardId: string(),
  paymentCardId: string(),
  activationTime: number(),
  expirationTime: number(),
};
